
const RadioButton = ({ attribute1, attribute2, id, label1, label2, checked1 = false, checked2= false, title = null, action1 = null, action2 = null}) => {
    return (
        <div>
            {title && <label className="block text-lg font-medium text-gray-700">
                {title}
            </label>}

            <div className="flex items-center gap-4 mt-2">
                <label className="flex items-center">
                    <input
                        type="radio"
                        name={id}
                        value={attribute1}
                        checked={checked1}
                        onChange={action1}
                        className="mr-2"
                    />
                    {label1}
                </label>
                <label className="flex items-center">
                    <input
                        type="radio"
                        name={id}
                        value={attribute2}
                        checked={checked2}
                        onChange={action2}
                        className="mr-2"
                    />
                    {label2}
                </label>
            </div>
        </div>
    )
}
export default RadioButton